import React from "react";
import { DashboardList } from "../components/features/Dashboard/DashboardList/DashboardList";

export const DashboardScreen = () => {
    return <DashboardList/>;
}